import Pristine from 'pristinejs';
import jump from 'jump.js';

// This function is called when Google Places script initialises, then trigger a custom
// event that the Alpine module is listening to.
window.aaShopCheckoutPlacesInit = () => {
	// Call the event a few times, it'll only receive the event once - this is safe.
	[1000, 2000, 3000].forEach((t) =>
		setTimeout(() => {
			jQuery(window).trigger('aaShopCheckoutPlacesInit');
		}, t)
	);
};

export default () => {
	let validator;
	let paymentButtonTextChangeActivated = false;
	const pristineConfig = {
		classTo: 'gfield',
		errorClass: 'gfield_error',
		successClass: 'gfield_success',
		errorTextParent: 'gfield',
		errorTextTag: 'div',
		errorTextClass: 'gfield_validation_message',
	};
	const elements = {};
	const gplaces = {
		// Next 2 variables control the visibility through the `updateAddressFieldsVisibility` method.
		billingAddressManual: false,
		shippingAddressManual: false,

		billingInstance: null,
		shippingInstance: null,
	};

	const findGooglePlacesAddressComponent = (
		components,
		type,
		name = 'long_name'
	) => {
		if (!components?.length) return '';

		const component = components.find((c) => c.types.includes(type));

		return (component && component[name]) || '';
	};

	return {
		init() {
			this.getElements();

			// Listen to this event ONCE.
			jQuery(window).one('aaShopCheckoutPlacesInit', () => {
				this.prepareGooglePlaces();
			});
		},
		getElements() {
			elements.$step1Container = jQuery(
				'.aa-checkout__step--step-1',
				this.$root
			);
			elements.$step2Container = jQuery(
				'.aa-checkout__step--step-2',
				this.$root
			);
			elements.$billingContainer = jQuery('.aa-checkout__billing', this.$root);
			elements.$shipingContainer = jQuery('.aa-checkout__shipping', this.$root);
			elements.$billingAutocompleteInput = jQuery(
				'#billing_gplaces',
				this.$root
			);
			elements.$shippingAutocompleteInput = jQuery(
				'#shipping_gplaces',
				this.$root
			);
		},
		prepareGooglePlaces() {
			this.addManualAddressTriggers();
			this.updateAddressFieldsVisibility();
			this.initGooglePlaces();
		},
		addManualAddressTriggers() {
			elements.$billingField = jQuery('#billing_gplaces_field', this.$root);
			elements.$shippingField = jQuery('#shipping_gplaces_field', this.$root);

			const billingAddressAllFilled = [
				jQuery(`#billing_address_1`, this.$root).val(),
				jQuery(`#billing_city`, this.$root).val(),
				jQuery(`#billing_state`, this.$root).val(),
				jQuery(`#billing_postcode`, this.$root).val(),
			].every((value) => !!value);

			const shippingAddressAllFilled = [
				jQuery(`#shipping_address_1`, this.$root).val(),
				jQuery(`#shipping_city`, this.$root).val(),
				jQuery(`#shipping_state`, this.$root).val(),
				jQuery(`#shipping_postcode`, this.$root).val(),
			].every((value) => !!value);

			if (!billingAddressAllFilled) {
				elements.$billingField.append(
					'<span class="gfield_description">Search for your address and select from the dropdown, or <a href="javascript:;" id="billing_gfield_manual_trigger">set your address manually</a>.</span>'
				);

				jQuery('#billing_gfield_manual_trigger', this.$root).on(
					'click',
					(e) => {
						e.preventDefault();

						this.enableManualAddressMode('billing');
					}
				);
			} else {
				this.enableManualAddressMode('billing');
			}

			if (!shippingAddressAllFilled) {
				elements.$shippingField.append(
					'<span class="gfield_description">Search for your address and select from the dropdown, or <a href="javascript:;" id="shipping_gfield_manual_trigger">set your address manually</a>.</span>'
				);

				jQuery('#shipping_gfield_manual_trigger', this.$root).on(
					'click',
					(e) => {
						e.preventDefault();

						this.enableManualAddressMode('shipping');
					}
				);
			} else {
				this.enableManualAddressMode('shipping');
			}
		},
		enableManualAddressMode(group) {
			if (group === 'billing') {
				elements.$billingField.hide();

				gplaces.billingAddressManual = true;
			} else {
				elements.$shippingField.hide();

				gplaces.shippingAddressManual = true;
			}

			this.updateAddressFieldsVisibility();
		},
		updateAddressFieldsVisibility() {
			const selectors = (group) =>
				[
					`#${group}_address_1_field`,
					`#${group}_city_field`,
					`#${group}_state_field`,
					`#${group}_postcode_field`,
					`#${group}_country_field`,
				].join(',');

			jQuery(selectors('billing'), this.$root).toggle(
				gplaces.billingAddressManual
			);
			jQuery(selectors('shipping'), this.$root).toggle(
				gplaces.shippingAddressManual
			);
		},
		initGooglePlaces() {
			gplaces.billingInstance = new google.maps.places.Autocomplete(
				elements.$billingAutocompleteInput[0],
				{
					componentRestrictions: { country: 'au' },
					fields: ['address_components', 'geometry'],
				}
			);
			gplaces.shippingInstance = new google.maps.places.Autocomplete(
				elements.$shippingAutocompleteInput[0],
				{
					componentRestrictions: { country: 'au' },
					fields: ['address_components', 'geometry'],
				}
			);

			google.maps.event.addListener(
				gplaces.billingInstance,
				'place_changed',
				() => {
					const place = gplaces.billingInstance.getPlace();

					this.handleGooglePlacesAddressChange('billing', place);
				}
			);
			google.maps.event.addListener(
				gplaces.shippingInstance,
				'place_changed',
				() => {
					const place = gplaces.shippingInstance.getPlace();

					this.handleGooglePlacesAddressChange('shipping', place);
				}
			);
		},
		handleGooglePlacesAddressChange(group, place) {
			let subPremise = findGooglePlacesAddressComponent(
				place.address_components,
				'subpremise'
			);
			const streetNumber = findGooglePlacesAddressComponent(
				place.address_components,
				'street_number'
			);
			const streetName = findGooglePlacesAddressComponent(
				place.address_components,
				'route'
			);

			subPremise = subPremise ? `${subPremise}/` : '';

			const address = `${subPremise}${streetNumber} ${streetName}`.trim();
			const suburb = findGooglePlacesAddressComponent(
				place.address_components,
				'locality',
				'long_name'
			);
			const postcode = findGooglePlacesAddressComponent(
				place.address_components,
				'postal_code',
				'long_name'
			);
			const state = findGooglePlacesAddressComponent(
				place.address_components,
				'administrative_area_level_1',
				'short_name'
			);

			jQuery(`#${group}_address_1`, this.$root).val(address);
			jQuery(`#${group}_city`, this.$root).val(suburb);
			jQuery(`#${group}_state`, this.$root).val(state);
			jQuery(`#${group}_postcode`, this.$root).val(postcode);

			this.enableManualAddressMode(group);
		},
		submit($event) {
			$event.preventDefault();
		},
		scrollToTop() {
			jump(document.body, {
				duration: 300,
				offset: -100,
				a11y: true,
			});
		},
		nextStep() {
			this.scrollToTop();
			this.$store.aa.formStepper.goTo(1);

			if (!paymentButtonTextChangeActivated) {
				paymentButtonTextChangeActivated = true;

				this.handleButtonLabelChanges();
			}
		},
		handleStep0() {
			const shippingSameAsBilling = jQuery(
				'#ship-to-different-address-checkbox',
				this.$root
			).is(':checked');
			const containerToValidate = shippingSameAsBilling
				? elements.$step1Container[0]
				: elements.$billingContainer[0];

			validator && validator.destroy();
			validator = new Pristine(containerToValidate, pristineConfig);

			if (validator.validate()) {
				jQuery('body').trigger('update_checkout');
				this.nextStep();
			} else {
				const firstError = validator.getErrors()[0];

				firstError && firstError.input.focus();
			}
		},
		handleButtonLabelChanges() {
			const addEvents = () => {
				jQuery(
					'#payment_method_aa_merchant_warrior, #payment_method_aa_stripe'
				).on('change', () => {
					jQuery('#place_order').text('Place order');
				});
				jQuery('#payment_method_aa_paypal').on('change', () => {
					jQuery('#place_order').text('Continue with PayPal');
				});
			};

			// Add events initially, then in case the cart gets updated and replaces the buttons,
			// we'll call it again with a slight delay to ensure this happens.
			addEvents();

			jQuery('body').on('updated_checkout', () => {
				setTimeout(() => {
					addEvents();
				}, 500);
			});
		},
	};
};
